import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ChipsItem } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Casino/CasinoFilterContext';

const CategoryFilterItem = ({ onSelect, option }) => {
  const { filter } = useCasinoFilterState();

  const selectedCategory = filter.categories && filter.categories[0];
  const active = parseInt(selectedCategory) === option.id;

  const onClick = useCallback(() => {
    if (active) return;

    onSelect(option.id);
  }, [active, onSelect, option.id]);

  return <ChipsItem active={active} label={option.name} onClick={onClick} />;
};

CategoryFilterItem.propTypes = {
  onSelect: PropTypes.func,
  option: PropTypes.object,
};

export default CategoryFilterItem;
